/* eslint-disable */ import { memoEval, violationsComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const boatShapeTopComponents = [
    attachComponent.withComponent(violationsComponent, 'default', true).withEntity('BoatShapeTop').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$violations
        ], ($violations)=>({
            violations: $violations
        })))
];

//# sourceMappingURL=boat-shape-top.js.map